import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST_LUMINAIRE_BRAND: 'LIST_LUMINAIRE_BRAND',
  LIST_LUMINAIRE_TYPE: 'LIST_LUMINAIRE_TYPE',
};

export const listLuminaireBrand = () => ({
  type: ACTION.LIST_LUMINAIRE_BRAND,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_LUMINAIRE_BRAND,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});

export const listLuminaireType = () => ({
  type: ACTION.LIST_LUMINAIRE_TYPE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_LUMINAIRE_TYPE,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/references/luminaire_actions.js